import { EventBus } from "../eventbus";
import uniqid from "uniqid";
import i18n from "./i18next.js";
import { map } from "./HelperFuncs";
import { unzip } from "unzipit";
import { baseUrl } from "../config";

const setBtn = (data, val) => {
  if (data.btn) {
    data.btn.disabled = val;
    console.log(data.btn.disabled);
  }
};

const getFoldersAndFiles = (data) => {
  switch (data.type) {
    case "multi":
      return data.items;

    case "file":
      return {
        selectedFiles: [data.item],
        selectedFolders: [],
      };

    case "folder":
      return {
        selectedFiles: [],
        selectedFolders: [data.item],
      };

    case "collection":
      return data.item;
  }

  return false;
};

const createDownloadLinkFiles = (items, specialAttrs = undefined, vueThis) => {
  // const items = getFoldersAndFiles(data);
  let downloadLink = `${baseUrl}/download?`;

  downloadLink += `files=${JSON.stringify(
    items.selectedFiles.map((file) => {
      if (typeof file === "object") {
        return file.file_id ? file.file_id : file.id;
      } else {
        //is string
        return file;
      }
    })
  )}`;

  downloadLink += `&folders=${JSON.stringify(
    items.selectedFolders.map((folder) => {
      if (typeof folder === "object") {
        return folder.folder_id ? folder.folder_id : folder.id;
      } else {
        //is string
        return folder;
      }
    })
  )}`;

  downloadLink += `&company=${vueThis.$store.state.company}`;

  if (specialAttrs) {
    specialAttrs.forEach((attr) => {
      downloadLink += `&${attr}=1`;
    });
  }

  if (vueThis.$store.state.user) {
    downloadLink += `&key=${vueThis.$store.state.user.key}`;
  }

  return downloadLink;
};

const createDownloadLinkCollection = (
  id,
  specialAttrs = undefined,
  vueThis
) => {
  let downloadLink = `${baseUrl}/collectiondownload?collection=${id}&company=${
    vueThis.$store.state.company
  }${vueThis.$store.state.user ? `&key=${vueThis.$store.state.user.key}` : ""}`;

  if (specialAttrs) {
    specialAttrs.forEach((attr) => {
      downloadLink += `&${attr}`;
    });
  }
  return downloadLink;
};

const createDownloadLink = (data, vueThis) => {
  const items = getFoldersAndFiles(data);

  if (data.type === "collection") {
    return createDownloadLinkCollection(items, data.specialAttrs, vueThis);
  }

  return createDownloadLinkFiles(items, data.specialAttrs, vueThis);
};

const setZipName = () => {
  const date = new Date();

  return `Sheprd_Download_${date.getDate()}-${
    date.getMonth() + 1
  }${date.getFullYear()}`;
};

export const download = (data, vueThis) => {
  const id = uniqid();

  setBtn(data, true);

  EventBus.$emit(`snackbar--add`, {
    id,
    title: i18n.t("common.downloading"),
    noTimer: true,
    progress: 0,
  });

  //enable btn
  setTimeout(() => {
    setBtn(data, false);
  }, 150);

  const zipName = data.item
    ? data.item.name
      ? data.item.name
      : setZipName()
    : setZipName();

  saveOrOpenBlob(createDownloadLink(data, vueThis), `${zipName}.zip`, data, id);
};

function saveOrOpenBlob(url, blobName, data, id) {
  let blob;
  const xmlHTTP = new XMLHttpRequest();

  //listen for cancel
  EventBus.$on("snackbar--remove", (cancelId) => {
    if (cancelId === id) {
      xmlHTTP.abort();
    }
  });

  xmlHTTP.open("GET", url, true);
  xmlHTTP.responseType = "arraybuffer";
  xmlHTTP.onload = function () {
    blob = new Blob([this.response]);
  };
  xmlHTTP.onprogress = function (pr) {
    EventBus.$emit(`snackbar-item--update`, {
      id,
      progress: map(pr.loaded, 0, pr.total, 0, 100),
    });
  };
  xmlHTTP.onloadend = function (e) {
    if (e.total <= e.loaded && e.loaded > 0 && e.total > 0) {
      const fileName = blobName;

      url = window.URL.createObjectURL(blob);

      //
      unzip(url)
        .then(({ entries }) => {
          const array = Object.entries(entries);
          const tempEl = document.createElement("a");
          document.body.appendChild(tempEl);
          tempEl.style = "display: none";

          if (Object.keys(entries).length === 1) {
            array.forEach(async ([name, entry]) => {
              const blob = await entry.blob();
              const fileUrl = URL.createObjectURL(blob);

              tempEl.href = fileUrl;
              tempEl.download = name;
              tempEl.click();
            });
          } else {
            tempEl.href = url;
            tempEl.download = fileName;
            tempEl.click();
          }
        })
        .then(() => {
          // window.URL.revokeObjectURL(url);
          setTimeout(() => {
            setBtn(data, false);
          }, 150);

          let fileData = {
            name: blobName,
            extension: "zip",
            thumbnail: null,
          };

          //close the snakbar-item
          if (data.item) {
            EventBus.$emit(`download--done`, data.item.id);
          }

          if (data.item) {
            fileData = data.item;
          }

          if (data.items) {
            if (data.items.selectedFiles) {
              if (data.items.selectedFiles.length === 1) {
                fileData = data.items.selectedFiles[0];
              }
            }
          }

          EventBus.$emit(`snackbar--remove`, id);
          EventBus.$emit(`snackbar--add`, {
            id: uniqid(),
            title: i18n.t("common.download_ready"),
            fileData: data.item
              ? data.item.name
                ? data.item
                : fileData
              : fileData,
            status: i18n.t("common.done"),
          });
        });
    }
  };

  xmlHTTP.send();
}
